<template>
	<div class="m-l-50 m-t-30 w-500">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
        <!-- <el-tab-pane label="商家基本信息" name="first"> -->
          <el-form-item label="用户姓名" prop="user_name">
            <el-input v-model.trim="form.user_name" placeholder="请输入用户姓名" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input v-model.trim="form.username" placeholder="请输入手机号" class="h-40 w-200"></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input v-model.trim="form.password" :disabled="true" class="h-40 w-200"></el-input>
          </el-form-item>
			<el-form-item>
				<el-button type="primary" @click="add('form')" :loading="isLoading" size="small">提 交</el-button>
				<el-button @click="goback()" size="small">返 回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<style type="text/css">
	.form-checkbox:first-child{
		margin-left: 15px;
	}
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        form: {
          user_name: '',
          username: '',
          password: '88888888'
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名' }
          ],
          user_name: [
            { required: true, message: '请输入用户姓名' }
          ]
        }
      }
    },
    methods: {
      add(form) {
        console.log('res = ', _g.j2s(this.form))
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/user', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      }
    },
    created() {
      _g.closeGlobalLoading()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// add.vue?6c7d982f